var searchParams = new URLSearchParams(window.location.search);

$('.product__info-container').on("click", "#bcpo .single-option-selector .bcpo-front-image-label", function () {
  if ($(this).attr('readonly') == 'readonly') {
    return;
  }
  var $parent = $(this).closest('.selector-wrapper');
  var $optionsparent = $(this).closest('.bcpo-image-parent');
  var $item = $optionsparent.find('input.bcpo-front-image-option');
  
  if ($parent.find('.bcpo-label span.bcpo-title').text() == 'Installation Method:') {
    // Installation Method
    $(`.popupShade[name=shadesPopup] .TypesPopup .popupBody`).removeClass('active');
    $(`.popupShade[name=shadesPopup] .TypesPopup .popupBody[data-type="${ $item.val() || 'Inside' }"]`).addClass('active');
  }
})

$('.product__info-container').on('change', "#bcpo select", function() {
  var width = 0, height = 0;
  if ($('select[name="properties[Single Panel Width]"]').length > 0) {
    width = parseFloat($('select[name="properties[Single Panel Width]"]').val().split('"')[0]) || 0;
    // 杆子长度超出45，提示截断
    $('.memoryTips').css('display', width > 45 ? 'block' : 'none');
  }
  if ($('select[name="properties[Single Panel Length]"]').length > 0) {
    height = parseFloat($('select[name="properties[Single Panel Length]').val().split('"')[0]) || 0;
  }
  // $('#MainContent #bcpo:not(.g-card) .selector-wrapper:has(select[name="properties[Single Panel Width]"])>.bcpo-label .bcpo-value, .total_length').text(`${width}" ${$('select[name="properties[Width Fraction]"]').val() || 0}`);
  // $('#MainContent #bcpo:not(.g-card) .selector-wrapper:has(select[name="properties[Single Panel Length]"])>.bcpo-label .bcpo-value, .total_length').text(`${height}" ${$('select[name="properties[Length Fraction]"]').val() || 0}`);
})

// 尺寸示意初始展示
function measurementsInit () {
  var width = 0, height = 0;
  var imgArr = {
    8785117577466: '/cdn/shop/files/modole_s_c.jpg',
    8785117511930: '/cdn/shop/files/modole_s_c.jpg',
    8785117610234: '/cdn/shop/files/14_9eb7a65e-d030-4c9d-85f7-f63445deba30.png',
  }
  var str = [];
  if ($('select[name="properties[Single Panel Width]"]').length > 0) {
    width = parseFloat($('select[name="properties[Single Panel Width]"]').val().split('"')[0]) || 0;
  }
  if ($('select[name="properties[Single Panel Length]"]').length > 0) {
    height = parseFloat($('select[name="properties[Single Panel Length]').val().split('"')[0]) || 0;
  }
  if (imgArr[productId]) {
    str.push(`<div class="measurementBox" style="flex-direction: column;align-items: center;border: none;">`);
    // 尺寸示意图
    str.push(`<img src="${ imgArr[productId] }" style="max-width: 50%;" />`);
    // 提示文案
    str.push(`<div class="tips" style="max-width: 100%;">`);
    if ($('h1.product__title').text().toLowerCase().includes('triangle')) {
      str.push(`<p>Please measure the distance between anchor points. In actual production, we will reduce the longgest side by 20 inches while maintaing the shape, to account for installation hardware and to ensure a stable attachment, proper tension and minimize sagging.</p>`);
    } else {
      str.push(`<p>Please measure the distance between anchor points. In actual production, we will reduce each side by 20 inches, to account for installation hardware and to ensure a stable attachment, proper tension and minimize sagging.</p>`);
    }
    str.push(`</div>`);
    str.push(`</div>`);

    if ($('select[name="properties[MEASUREMENTS C-A]"]').length > 0) {
      $('.selector-wrapper:has(select[name="properties[MEASUREMENTS C-A]"])').after(str.join(''));
    } else {
      $('.selector-wrapper:has(select[name="properties[MEASUREMENTS B-C]"])').after(str.join(''));
    }
  }
  $('[data-unique="_s1lzvkewu"]').after('<div class="measurementBox" style="flex-direction: column;align-items: center;border: none;"><img src="/cdn/shop/files/14_9eb7a65e-d030-4c9d-85f7-f63445deba30.png" style="max-width: 50%;"><div class="tips" style="max-width: 100%;"><p>Please measure the distance between anchor points. In actual production, we will reduce each side by 20 inches, to account for installation hardware and to ensure a stable attachment, proper tension and minimize sagging.</p></div></div>');
  // $('#MainContent #bcpo:not(.g-card) .selector-wrapper:has(select[name="properties[Single Panel Width]"])>.bcpo-label .bcpo-value, .total_length').text(`${width}" ${$('select[name="properties[Width Fraction]"]').val() || 0}`);
  // $('#MainContent #bcpo:not(.g-card) .selector-wrapper:has(select[name="properties[Single Panel Length]"])>.bcpo-label .bcpo-value, .total_length').text(`${height}" ${$('select[name="properties[Length Fraction]"]').val() || 0}`);
}

window.addEventListener("load", function (event) {
  // 长度超出 45 Inches 提示
  // $('.selector-wrapper:has(select[name="properties[Single Panel Width]"]),.selector-wrapper:has(select[name="properties[Width Fraction]"])').append(`<div class="memoryTips">No-drill application not recommended for width over 45 inches.</div>`);
  $('.selector-wrapper:has(select[name="properties[Width Fraction]"])').after(`<div class="memoryTips">No-drill application not recommended for width over 45 inches.</div>`);
  $('#bcpo select').change();
  
  measurementsInit ();
  // Installation Method
  if ($('.selector-wrapper:has(input[name="properties[Installation Method]"])').length > 0) {
    $('.selector-wrapper:has(input[name="properties[Installation Method]"])').append(`<div id="TypesPopup" class="btn" type="link" name="shadesPopup" onclick="TypesPopupOpen(event, this)">More Info On Shades Measurement</div>`);
  }
  // if (searchParams.get("fwidth") != null) {
  //   $('select[name="properties[Single Panel Width]"]').val(`${searchParams.get("fwidth")}"`);
  //   $('select').change();
  // }
});